var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19.5C13.6567 19.5 13.0766 19.3241 12.5833 18.9944C12.0899 18.6648 11.7054 18.1962 11.4784 17.648C11.2513 17.0999 11.1919 16.4967 11.3076 15.9147C11.4234 15.3328 11.7091 14.7982 12.1287 14.3787C12.5482 13.9591 13.0828 13.6734 13.6647 13.5576C14.2467 13.4419 14.8499 13.5013 15.398 13.7284C15.9462 13.9554 16.4148 14.3399 16.7444 14.8333C17.0741 15.3266 17.25 15.9067 17.25 16.5C17.2491 17.2954 16.9327 18.0579 16.3703 18.6203C15.8079 19.1828 15.0454 19.4991 14.25 19.5ZM14.25 15C13.9533 15 13.6633 15.088 13.4166 15.2528C13.17 15.4176 12.9777 15.6519 12.8642 15.926C12.7506 16.2001 12.7209 16.5017 12.7788 16.7926C12.8367 17.0836 12.9796 17.3509 13.1893 17.5607C13.3991 17.7704 13.6664 17.9133 13.9574 17.9712C14.2483 18.0291 14.5499 17.9994 14.824 17.8858C15.0981 17.7723 15.3324 17.58 15.4972 17.3334C15.662 17.0867 15.75 16.7967 15.75 16.5C15.7496 16.1023 15.5914 15.721 15.3102 15.4398C15.029 15.1586 14.6477 15.0004 14.25 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21.75H8.25C7.85218 21.75 7.47064 21.592 7.18934 21.3107C6.90804 21.0294 6.75 20.6478 6.75 20.25V13.5C6.75 13.1022 6.90804 12.7206 7.18934 12.4393C7.47064 12.158 7.85218 12 8.25 12H10.7095L11.1175 10.7757C11.2171 10.477 11.4081 10.2172 11.6635 10.0331C11.9189 9.84906 12.2258 9.75 12.5406 9.75H15.9594C16.2742 9.75 16.5811 9.84906 16.8365 10.0331C17.0919 10.2172 17.2829 10.477 17.3825 10.7757L17.7905 12H20.25C20.6478 12 21.0294 12.158 21.3107 12.4393C21.592 12.7206 21.75 13.1022 21.75 13.5V20.25C21.75 20.6478 21.592 21.0294 21.3107 21.3107C21.0294 21.592 20.6478 21.75 20.25 21.75ZM8.25 20.25H20.25V13.5H16.7094L15.9594 11.25H12.5405L11.7905 13.5H8.25V20.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.25H20.25V9.75H21.75V8.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.25H20.25V6.75H21.75V5.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 2.25H20.25V3.75H21.75V2.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.25H17.25V3.75H18.75V2.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25H14.25V3.75H15.75V2.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2.25H11.25V3.75H12.75V2.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.25H8.25V3.75H9.75V2.25Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.25H5.25V3.75H6.75V2.25Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.25H2.25V3.75H3.75V2.25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.25H2.25V6.75H3.75V5.25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.25H2.25V9.75H3.75V8.25Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.25H2.25V12.75H3.75V11.25Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.25H2.25V15.75H3.75V14.25Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 17.25H2.25V18.75H3.75V17.25Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 20.25H2.25V21.75H3.75V20.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic-camera.b7a985106d6a6d37b7d24b99c7bf2c56.svg";
export { ForwardRef as ReactComponent };